/**
 * 弹框打开时锁定页面滚动，关闭后恢复。
 * 带 data-body-scroll-lock-scrollable 标记的区域仍可滚动（用于弹框内列表）。
 */
const SCROLLABLE_SELECTOR = '[data-body-scroll-lock-scrollable]';

/** 嵌套弹框计数，避免多层弹框时提前解锁 */
let lockCount = 0;let scrollTop = 0;
let bodyStyleBackup: {
    position: string;
    top: string;
    left: string;
    width: string;
    overflow: string;
    htmlOverflow: string;
} | null = null;

/** 阻止 iOS 背景滚动，但放行弹框内可滚动区域 */
const preventTouchMove = (event: TouchEvent) => {    const target = event.target;
    if (!(target instanceof Element)) {
        event.preventDefault();
        return;
    }

    if (target.closest(SCROLLABLE_SELECTOR)) {
        return;
    }

    event.preventDefault();
};

/** 锁定 body 滚动并记录当前位置 */
export const lockBodyScroll = () => {    if (typeof document === 'undefined') {
        return;
    }

    lockCount += 1;
    if (lockCount > 1) {
        return;
    }

    scrollTop = window.pageYOffset
        || document.documentElement.scrollTop
        || document.body.scrollTop
        || 0;

    const { body } = document;
    bodyStyleBackup = {
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        width: body.style.width,
        overflow: body.style.overflow,
        htmlOverflow: document.documentElement.style.overflow,
    };

    body.style.position = 'fixed';
    body.style.top = `-${scrollTop}px`;
    body.style.left = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('touchmove', preventTouchMove, { passive: false });
};

/** 恢复 body 滚动并回到锁定前的位置 */
export const unlockBodyScroll = () => {    if (typeof document === 'undefined') {
        return;
    }

    lockCount = Math.max(0, lockCount - 1);
    if (lockCount > 0) {
        return;
    }

    document.removeEventListener('touchmove', preventTouchMove);

    const { body } = document;
    if (bodyStyleBackup) {
        body.style.position = bodyStyleBackup.position;
        body.style.top = bodyStyleBackup.top;
        body.style.left = bodyStyleBackup.left;
        body.style.width = bodyStyleBackup.width;
        body.style.overflow = bodyStyleBackup.overflow;
        document.documentElement.style.overflow = bodyStyleBackup.htmlOverflow;
        bodyStyleBackup = null;
    } else {
        body.style.position = '';
        body.style.top = '';
        body.style.left = '';
        body.style.width = '';
        body.style.overflow = '';
        document.documentElement.style.overflow = '';
    }

    window.scrollTo(0, scrollTop);
};
